import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NastaPills',
  setup(__props) {

const interacted = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nasta-pills", interacted.value ? 'interacted' : '']),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (interacted.value = true))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})